import React from 'react'
import PropTypes from 'prop-types'
import {Text, Box} from '@chakra-ui/react'
import {destructureAmount} from '../../../../../utils/formatter'

const SummaryTotal = ({amount, isLoading}) => {
  const [_s, unit, delimeter, subunit] = destructureAmount(amount)

  return (
    <Box
      display="flex"
      color={isLoading ? 'mld.neutral.500' : null}
      data-testid="summary-total"
      letterSpacing={0}
    >
      <Text fontSize="4xl">{unit}</Text>
      <Text fontSize="md" pt="8px">
        {delimeter}
        {subunit}
      </Text>
    </Box>
  )
}

SummaryTotal.propTypes = {
  amount: PropTypes.shape({
    toFormat: PropTypes.func.isRequired,
  }).isRequired,
  isLoading: PropTypes.bool,
}

SummaryTotal.defaultProps = {
  isLoading: false,
}

export default SummaryTotal
